import Swiper from 'swiper';
import scrollIntoView from 'scroll-into-view-if-needed';

const setupSpecCategoryButtonEvents = function(specContainer) {
    const specAccordians = specContainer.querySelectorAll('.cms-content-trim-level__spec-button');
    const specAccordiansLength = specAccordians.length;
    if (specAccordiansLength > 0) {
        for (let index = 0; index < specAccordiansLength; index++) {
            specAccordians[index].addEventListener("click", function (e) {
                specContainer.querySelectorAll('.cms-content-trim-level__spec-button--active').forEach(activeButton => {
                    if (activeButton == this) {
                        return;
                    }
                    activeButton.classList.remove('cms-content-trim-level__spec-button--active');
                });
                this.classList.add('cms-content-trim-level__spec-button--active');

                // Get the element that the button controls the display for
                const specListContainer = specContainer.querySelector('#' + this.getAttribute('aria-controls'))
                // Hide all elements but the one we're opening
                specContainer.querySelectorAll('.cms-content-trim-level__spec').forEach(openedSpec => {
                    if (openedSpec == specListContainer) {
                        return;
                    }
                    openedSpec.setAttribute('aria-expanded', 'false');
                    openedSpec.classList.add('cms-content-trim-level__collapse');
                });
                specListContainer.setAttribute('aria-expanded', 'true');
                specListContainer.classList.remove('cms-content-trim-level__collapse');

                if (window.headroom) {
                    window.headroom.unpin();
                    window.headroom.freeze();
                }
                scrollIntoView(specListContainer, { behavior: 'smooth', scrollMode: 'if-needed' })
                window.headroom.unfreeze();
            });
        }
    }
}

export default function (cmsContentSliceContainerElement) {
    cmsContentSliceContainerElement.querySelectorAll('.cms-content-trim-level__spec-container').forEach(specContainer => {
        setupSpecCategoryButtonEvents(specContainer);
    })

    // const specAccordians = cmsContentSliceContainerElement.querySelectorAll('.cms-content-trim-level__spec-button');
    // const specAccordiansLength = specAccordians.length;
    // if (specAccordiansLength > 0) {
    //     for (let index = 0; index < specAccordiansLength; index++) {
    //         specAccordians[index].addEventListener("click", function (e) {
    //             cmsContentSliceContainerElement.querySelectorAll('.cms-content-trim-level__spec-button--active').forEach(activeButton => {
    //                 if (activeButton == this) {
    //                     return;
    //                 }
    //                 activeButton.classList.remove('cms-content-trim-level__spec-button--active');
    //             });
    //             this.classList.add('cms-content-trim-level__spec-button--active');

    //             const specContainer = cmsContentSliceContainerElement.querySelector('#' + this.getAttribute('aria-controls')) //get the element that the button controls the display for
    //             cmsContentSliceContainerElement.querySelectorAll('.cms-content-trim-level__spec').forEach(openedSpec => {
    //                 if (openedSpec == specContainer) {
    //                     return;
    //                 }
    //                 openedSpec.setAttribute('aria-expanded', 'false');
    //                 openedSpec.classList.add('cms-content-trim-level__collapse');
    //             });
    //             specContainer.setAttribute('aria-expanded', 'true');
    //             specContainer.classList.remove('cms-content-trim-level__collapse');

    //             if (window.headroom) {
    //                 window.headroom.unpin();
    //                 window.headroom.freeze();
    //             }
    //             scrollIntoView(specContainer, { behavior: 'smooth', scrollMode: 'if-needed' })
    //             window.headroom.unfreeze();
    //         });
    //     }
    // }

    cmsContentSliceContainerElement.querySelectorAll('.cms-content-trim-level__spec-categories').forEach(buttonsContainer => {
        new Swiper(buttonsContainer, {
            grabCursor: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: 400,
            direction: 'vertical',
            breakpoints: {
                768: {
                    direction: 'horizontal',
                    spaceBetween: 20,
                },
            },
        });
    })


    const specLinks = cmsContentSliceContainerElement.querySelectorAll('[data-spec-id]')
    const specLinksLength = specLinks.length;
    if (specLinksLength <= 0) {
        return;
    }

    const specContainers = cmsContentSliceContainerElement.querySelectorAll('[data-spec-details]')
    const specContainersLength = specContainers.length;

    for (let i = 0; i < specLinksLength; i++) {
        specLinks[i].addEventListener("click", function (e) {
            e.preventDefault()
            for (let index = 0; index < specContainersLength; index++) {
                specContainers[index].style.display = "none"
            }
            const specList = cmsContentSliceContainerElement.querySelector("[data-spec-details='" + this.dataset.specId + "']")
            specList.style.display = "block";

            if (window.headroom) {
                window.headroom.unpin();
                window.headroom.freeze();
            }
            scrollIntoView(specList, { behavior: 'smooth', scrollMode: 'always' })
            window.headroom.unfreeze();
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/modules/trim-level.js